<template>
    <div class="qualityenterprise whitebox" style="height: 100vh;" v-title :data-title="title">
        <leftnav class="fl" mkcode="D" :itemcode="itemcode"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
                <freeUserTips :type="4" :bgtype="0"></freeUserTips>
            </el-dialog>
            <div class="whitebox right_topbox">
                <div class="right_boxtitle map_title_tab">
                    <span class="title" :class="pageType == 1 ? 'current' : ''"
                        @click="handlerPageType(1)">行业研究AI智能体（测试版）</span>
                    <span class="title" :class="pageType == 2 ? 'current' : ''"
                        @click="handlerPageType(2)">定制研究AI智能体</span>

                    <div class="fr right_boxtitle search-box nz-search-box">
                        <span class="searchtype">行业</span>
                        <input type="text" placeholder="请输入行业关键词" class="search-input" v-model="searchtext"
                            @keydown="searchenter" />
                        <button class="search-btn" @click="searchkwfun">查询</button>
                    </div>
                </div>
                <div class="opport-screen-list1">
                    <span class="fl dib py-1 bdbe widthPC-100" v-show="pageType == 1"
                        style="line-height: 32px;">本页内容由<b>行业研究AI智能体生成</b>，该智能体封装了<b>国际顶级投行及咨询公司的研究框架</b>，可以视为行业研究的“数字员工”，
                        分析能力接近<b>行业专家水平。</b><br />
                        <em class="bluefont">SVIP用户</em>，<b>可个性定制AI研究智能体</b>，即根据本企业个性信息和分析逻辑，定制专属AI智能体。 <a
                            @click="openSmWindow('https://wpa1.qq.com/lwDa6cb4?_type=wpa&qidian=true')"
                            class="cur-pointer bluefont">定制咨询 ></a></span>
                    <span class="fl dib py-1 bdbe widthPC-100" v-show="pageType == 2"
                        style="line-height: 32px;">本页内容是根据用户个性需求定制的AI研究智能体，本页内容为私有信息，仅用户本账户可见。 <br />
                        用户可以结合自身需求和对效果的评估过，要求不断优化优化智能体分析模型，以提升效果。<br />
                        由于大模型固有特点，结果在细节上会有幻觉，但综合结论可信度在八成以上。
                    </span>
                    <dl class="opport-screen bdbe">
                        <dt class="fl">一级行业</dt>
                        <dd class="fl">
                            <span :class="industryValue == 0 ? 'a-screen current' : 'a-screen'"
                                @click="chooseIndutry({ paraValue: 0, paraName: '全部' }, 1)">全部</span>

                            <span :class="industryValue == list.value ? 'a-screen current' : 'a-screen'"
                                @click="chooseFuture(list, 1)" :key="'future' + i" v-for="(list, i) in futureList">{{
                                    list.name }}<em v-show="futureListCount != 0">({{ futureListCount }})</em></span>
                            <span :class="industryValue == list.paraValue ? 'a-screen current' : 'a-screen'"
                                @click="chooseIndutry(list, 1)" :key="i" v-for="(list, i) in industryList">{{
                                    list.paraName }}<em v-show="list.count && list.count">({{ list.count
                                    }})</em></span>
                        </dd>
                    </dl>
                    <dl class="opport-screen bdbe" v-show="industryList2.length > 0">
                        <dt class="fl">二级行业</dt>
                        <dd class="fl">
                            <span :class="industryValue2 == 0 ? 'a-screen current' : 'a-screen'"
                                v-show="industryValue != 'w0'"
                                @click="chooseIndutry({ paraValue: 0, paraName: '全部' }, 2)">全部</span>
                            <span :class="industryValue2 == list.paraValue ? 'a-screen current' : 'a-screen'"
                                v-show="industryValue != 'w0'" @click="chooseIndutry(list, 2)" :key="i"
                                v-for="(list, i) in industryList2">{{
                                    list.paraName }}<em v-show="list.count && list.count != ''">({{ list.count
                                }})</em></span>
                            <span :class="industryValue2 == list.value ? 'a-screen current' : 'a-screen'"
                                v-show="industryValue == 'w0'" @click="chooseFuture(list, 2)" :key="'future_' + i"
                                v-for="(list, i) in industryList2">{{
                                    list.name }}<em v-show="list.count && list.count != ''">({{ list.count
                                    }})</em></span>
                        </dd>
                    </dl>
                </div>
            </div>
            <!-- <div class="whitebox right_topbox">
                <div class="right_boxtitle">
                    <span class="fl right_title"></span>
                    <span class="fl right_title ml-3">行业研究AI智能体（测试版）</span>
                    <span class="fl dib py-1 ml-5"
                        style="line-height: 32px;">本页内容由<b>行业研究AI智能体生成</b>，该智能体封装了<b>国际顶级投行及咨询公司的研究框架</b>，可以视为行业研究的“数字员工”，
                        分析能力接近<b>行业专家水平。</b><br />
                        <em class="bluefont">SVIP用户</em>，<b>可个性定制AI研究智能体</b>，即根据本企业个性信息和分析逻辑，定制专属AI智能体。 <a
                            @click="openSmWindow('https://wpa1.qq.com/lwDa6cb4?_type=wpa&qidian=true')"
                            class="cur-pointer bluefont">定制咨询 ></a></span>
                </div>
                
            </div> -->

            <div class="investment-opportunity-table" v-show="pageType == 1">
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column label="投资机会点">
                        <template slot-scope="scope">
                            <span class="curp" @click="routerblank('/tradeDetail?id=' + scope.row.id)">{{
                                scope.row.title
                                }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="一级行业">
                        <template slot-scope="scope">
                            <span>{{ scope.row.industry1Text }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="二级行业">
                        <template slot-scope="scope">
                            <span>{{ scope.row.industry2Text }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="投资机会大小">
                        <el-table-column label="市场空间">
                            <template slot-scope="scope">
                                <span>{{ scope.row.fiveYears }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="技术进步">
                            <template slot-scope="scope">
                                <span>{{ scope.row.techCompete }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="政策支持">
                            <template slot-scope="scope">
                                <span>{{ scope.row.policySupport }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="综合" class-name="zonghe-opportunity">
                            <template slot-scope="scope">
                                <span>{{ scope.row.investChanceScore }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="进入是否容易">
                        <el-table-column label="竞争格局">
                            <template slot-scope="scope">
                                <span>{{ scope.row.industryCompete }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="盈利水平">
                            <template slot-scope="scope">
                                <span>{{ scope.row.industryProfit }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="进入门槛">
                            <template slot-scope="scope">
                                <span>{{ scope.row.entryThreshold }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="综合" class-name="zonghe-strategy">
                            <template slot-scope="scope">
                                <span>{{ scope.row.entryEasyScore }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="投资时机好坏">
                        <el-table-column label="行业阶段">
                            <template slot-scope="scope">
                                <span>{{ scope.row.developStage }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="技术进步">
                            <template slot-scope="scope">
                                <span>{{ scope.row.techStage }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="资本支持">
                            <template slot-scope="scope">
                                <span>{{ scope.row.capitalSupport }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="综合" class-name="zonghe-risk">
                            <template slot-scope="scope">
                                <span>{{ scope.row.entryChanceScore }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>

                </el-table>
                <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                    <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                        v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                </div>
            </div>
            <div class="investment-opportunity-table" v-show="pageType == 2">
                <el-table :data="cumTableData" border style="width: 100%">
                    <el-table-column label="项目名称" width="300">
                        <template slot-scope="scope">
                            <span class="curp"
                                @click="routerblank('/tradeDetail?id=' + scope.row.id + '&isCumtrade=1')">{{
                                    scope.row.title
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="研究结论">
                        <template slot-scope="scope">
                            <span>{{
                                scope.row.researchResult
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="详情" width="200">
                        <template slot-scope="scope">
                            <span class="curp"
                                @click="routerblank('/tradeDetail?id=' + scope.row.id + '&isCumtrade=1')">详情></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "investmentOpportunity",
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse']),

    },
    data() {
        return {
            title: '行业机会库',
            pageType: 1,
            cumTableData: [],
            tableData: [
                {
                    investmentPoint: '工业机器人',
                    primaryIndustry: 'B',
                    secondaryIndustry: 'C',
                    marketDemand: 'D',
                    technicalProgress: 'E',
                    opportunityComposite: 'F',
                    entryBarrier: 'G',
                    industryRisk: 'H',
                    riskComposite: 'I',
                    resourceMatch: 'J',
                    capabilityMatch: 'K',
                    strategyComposite: 'L'
                },
            ],
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            reportList: [],
            industryList: [],
            industryList2: [],
            industryValue: 0,
            industryValue2: 0,
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            isShowFreeUserTips: false,
            yj_itemcode: 'R-BGQK',
            biglist: [{
                name: "未来产业",
                value: 'w0',
                itemcode: "R-WLCY",
            },
            {
                name: "数字经济",
                value: 10005,
                itemcode: "R-SZJJ",
            },
            {
                name: "高端制造",
                value: 10014,
                itemcode: "R-GDZZ",
            },
            {
                name: "能源环保材料",
                value: 10024,
                itemcode: "R-NYHBCL",
            },
            {
                name: "现代服务业",
                value: 10018,
                itemcode: "R-XDFWY",
            },
            {
                name: "大消费",
                value: 10029,
                itemcode: "R-DXF",
            },

            {
                name: "基建与投资",
                value: 10034,
                itemcode: "R-JJYTZ",
            },
            {
                name: "大健康",
                value: 10001,
                itemcode: "R-DJK",
            },
            {
                name: "报告全库",
                value: 0,
                itemcode: "R-BGQK",
            },
            {
                name: "月度报告",
                value: 10055,
                itemcode: "R-YDBG",
            },

            ],
            futureList: [],
            kwtextsearchtext: "",
            searchtext: "",
            itemcode: "B-HYYJAI",
            paramsCount: "",
            futureListCount: 0,
        };
    },
    created() {
        // this.fetchData();
    },
    mounted() {
        this.userdata = this.getuseriformation();
        this.getparameterList(0);
        if (this.curWebsite.type == 6) {
            this.itemcode = 'R-HYYJAI';

        }
    },
    methods: {
        handlerPageType(type) {
            this.pageType = type;
            this.industryValue = 0;
            this.industryValue2 = 0;
            this.industryList2 = [];
            if (type == 1) {
                this.getList();
            } else {
                this.getCumTableData().then((res) => {
                    // this.paramsCountList();
                });
            }
            
        },
        //在线客服打开新窗口
        openSmWindow(url) {
            try {
                window.open(url, "_blank", "height=600,width=800,top=200,left=200,status=yes,toolbar=no,menubar=no,resizable=yes,scrollbars=no,location=no,titlebar=no");
                _hmt.push(['_trackEvent', '报告', '咨询', '在线客服'])
            } catch (e) { }
            return false;
        },
        getList(pages, type) {
            return new Promise((resolve, reject) => {
                var _this = this;
                this.page = pages ? pages : 1;
                this.bus.$emit('loading', true);
                let searchKw = this.splicing('kw', this.searchtext);
                let industry1 = this.splicing('industry1', this.industryValue);
                let industry2 = this.splicing('industry2', this.industryValue2);
                var ajaxurl = this.$api.common.analyse.list() + '?page=' + this.page + industry1 + industry2 + searchKw;
                this.$axios.get(ajaxurl).then(function (res) {
                    if (res.data.success) {
                        console.log('列表', res, ajaxurl);
                        _this.tableData = res.data.list;
                        _this.totalPage = res.data.totalPage;
                        _this.pageSize = res.data.pageSize;
                        _this.total = res.data.totalRecord;
                        _this.paramsCount = res.data.data;
                        _this.paramsCountList();
                        _this.bus.$emit('loading', false);
                        resolve();
                    } else {
                        reject();
                    }
                }).catch(function (error) {
                    reject();
                    _this.bus.$emit('loading', false);
                    // 请求失败处理 console.log(error);
                });
            });
        },
        getCumTableData(pages, type) {
            return new Promise((resolve, reject) => {
                var _this = this;
                this.page = pages ? pages : 1;
                this.bus.$emit('loading', true);
                let searchKw = this.splicing('kw', this.searchtext);
                let industry1 = this.splicing('industry1', this.industryValue);
                let industry2 = this.splicing('industry2', this.industryValue2);
                var ajaxurl = this.$api.common.customized.list() + '?page=' + this.page + industry1 + industry2 + searchKw;
                this.$axios.get(ajaxurl).then(function (res) {
                    if (res.data.success) {
                        console.log('列表', res, ajaxurl);
                        _this.cumTableData = res.data.list;
                        _this.totalPage = res.data.totalPage;
                        _this.pageSize = res.data.pageSize;
                        _this.total = res.data.totalRecord;
                        _this.paramsCount = res.data.data;
                        _this.paramsCountList();
                        resolve(res.data);
                        _this.bus.$emit('loading', false);
                    } else {
                        reject(error);
                    }
                }).catch(function (error) {
                    reject(error);
                    _this.bus.$emit('loading', false);
                    // 请求失败处理 console.log(error);
                });
            });
        },
        chooseFuture(list, step) {
            console.log(list, step);
            if (step == 1) {
                // this.yj_itemcode = list.itemcode;
                this.industryValue = list.value;
                this.industryList2 = list.children;
                this.chooseFuture(list.children[0], 2);
                // document.title = list.name;
            } else {
                console.log(list.reportList);
                this.industryValue2 = list.value;
                // this.tableData = list.reportList;
            }
            this.getList();
            this.total = this.reportList.length;
            // console.log(this.industryList2,this.industryValue);
        },
        //获取未来产业参数及列表，参数用的列表里面的一级name
        getFutureList() {
            var _this = this;
            var ajaxurl = this.$api.cyl.report.futureIndustry();
            this.bus.$emit('loading', true);
            this.$axios.get(ajaxurl).then(function (res) {
                if (res.data.success) {
                    let data = res.data.list;
                    let list = { name: '未来产业', value: 'w0', itemcode: 'R-WLCY', children: data };
                    _this.futureList.push(list);
                    console.log('未来产业', _this.futureList);
                    if (_this.industryValue == 'w0') {
                        _this.chooseFuture(list, 1);
                    }
                    _this.getList().then((res) => {
                        _this.paramsCountList();
                    });
                    _this.bus.$emit('loading', false);
                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        //处理参数统计数量
        paramsCountList() {
            // 确保数据存在
            if (!this.industryList || !this.paramsCount || !this.paramsCount.industry1 || !this.paramsCount.industry2) {
                console.warn('行业列表或统计参数不存在');
                return;
            }

            console.log('参数统计数量', this.paramsCount, this.industryList);
            // 初始化 futureListCount 为 0
            this.futureListCount = 0;

            // 遍历 futureList 的 children，并匹配统计数据
            if (this.futureList[0].children) {
                const children = this.futureList[0].children;
                children.forEach(child => {
                    // 在 paramsCount.future 中查找与当前 child.value 匹配的统计数据
                    const matchingParam = this.paramsCount.future.find(param => param.id == child.value);

                    if (matchingParam) {
                        // 如果找到匹配项，将统计数量赋值给 child.count
                        child.count = matchingParam.count;

                        // 累加到 futureListCount
                        this.futureListCount += matchingParam.count;
                    } else {
                        // 如果没有匹配项，确保 count 为 0
                        child.count = 0;
                    }
                });
            }

            // 遍历 industryList 的一级数据
            this.industryList.forEach(industry => {
                // 匹配一级数据对应的 industryParams1
                const matchingIndustryParam1 = this.paramsCount.industry1.find(param => { return param.id == industry.paraValue });
                if (matchingIndustryParam1) {
                    // 如果找到匹配项，将统计数量赋值给 industry.count
                    industry.count = matchingIndustryParam1.count;
                } else {
                    // 如果没有匹配项，确保 count 为 0
                    industry.count = 0;
                }

                // 如果存在子集（children），匹配子集数据对应的 industryParams2
                if (industry.children && Array.isArray(industry.children)) {
                    industry.children.forEach(child => {
                        const matchingIndustryParam2 = this.paramsCount.industry2.find(param => param.id == child.paraValue);

                        if (matchingIndustryParam2) {
                            // 如果找到匹配项，将统计数量赋值给 child.count
                            child.count = matchingIndustryParam2.count;
                        } else {
                            // 如果没有匹配项，确保 count 为 0
                            child.count = 0;
                        }
                    });
                }
            });

            console.log('行业列表统计完成:', this.industryList, this.futureList);
        },
        chooseIndutry(list, step) {
            if (step == 1) {
                if (list.paraValue == 0) {
                    this.industryValue = 0;
                    this.industryValue2 = 0;
                    this.industryList2 = [];
                    console.log(list);
                } else {
                    this.industryValue = list.paraValue;
                    this.industryList2 = list.children;
                    this.industryValue2 = '';
                }
            } else if (step == 2) {
                // if (!this.userdata.token) {
                // 	this.isShowFreeUserTips = true;
                // 	return;
                // }
                console.log(2, list);
                this.industryValue2 = list.paraValue;
            }
            this.searchtext = '';
            if (this.pageType == 1) {
                this.getList();
            } else {
                this.getCumTableData();
            }
        },
        getparameterList(value) {
            var _this = this;
            console.log(this.$api.cyl)
            var ajaxurl = this.$api.cyl.report.industryList();

            this.$axios.get(ajaxurl).then(function (res) {
                if (res.data.success) {
                    console.log('行业参数', res);
                    let industry = res.data.list;
                    industry = industry.filter(item => item.paraName != '月度报告');
                    // 根据 biglist 中的 name 顺序，重新排列 industry,Sam说要按照左侧菜单栏排序
                    const sortedList = _this.biglist.map(item => {
                        return industry.find(node => node.paraName === item.name);
                    }).filter(item => item !== undefined);
                    _this.industryList = sortedList;
                    console.log('排序后', sortedList);
                    _this.getFutureList();
                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        //搜索关键词
        searchkwfun() {
            this.searchtext = $.trim(this.searchtext);
            if (this.searchtext.length > 0) {
                this.kwtextsearchtext = this.searchtext;
                if (this.pageType == 1) {
                    this.getList();
                } else {
                    this.getCumTableData();
                }
            } else {
                this.$message({
                    type: 'error',
                    message: '请输入关键词搜索',
                });
            }
        },
        searchenter(e) {
            if (e.keyCode == 13) {
                this.searchkwfun();
            }
        },
        pageHandler: function (page) {
            if (this.pageType == 1) {
                this.getList(page);
            } else {
                this.getCumTableData(page);
            }

        },
    }
};
</script>

<style lang="scss">
.investment-opportunity-table {
    margin: 20px;
}

.el-table td .cell {
    text-align: center;
}

.el-table {
    th {
        background: #f3f7ff !important;

        .cell {
            text-align: center;
            text-overflow: ellipsis;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            color: #333;
            font-weight: bold;
            font-size: 16px;
        }
    }
}


.el-table thead.is-group th.el-table__cell {
    background: #f3f7ff !important;
    color: #333;
    font-size: 16px;
    text-align: center;
}

.investment-opportunity-table {
    margin: 20px;
}

.el-table thead.is-group th.el-table__cell {
    background: #f3f7ff !important;
    color: #333;
    font-size: 16px;
    text-align: center;
}

.zonghe-opportunity {
    background: #f3f7ff !important;
    /* 投资机会大小的综合 */
}

.zonghe-risk {
    background: #f3f7ff !important;
    /* 机会与风险权衡的综合 */
}

.zonghe-strategy {
    background: #f3f7ff !important;
    /* 战略匹配的综合 */
}

.cur-pointer.bluefont {
    &:hover {
        color: #0080ff;
    }
}
</style>